import { useEffect, useState } from "react";
import {
    getSpaces,
    createSpace,
    updateSpace,
    deleteSpace,
} from "../../../../_api/Space";
import { getEstablishments } from "../../../../_api/Establishment"; // Nouvel import
import { uploadFile } from "../../../../_api/Storage"; // ton appel API S3

const PlaceholderSVG = () => (
    <div className="h-48 w-full bg-gray-100 flex items-center justify-center">
        <svg
            className="w-12 h-12 text-gray-400"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M3 5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5z"
            />
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M21 15l-5-5L5 21"
            />
        </svg>
    </div>
);

export const EspaceList = () => {
    const [spaces, setSpaces] = useState([]);
    const [showSidebar, setShowSidebar] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteNumber, setDeleteNumber] = useState(null);

    const [loading, setLoading] = useState(true);

    const fetchSpaces = async () => {
        setLoading(true);
        const res = await getSpaces();
        setSpaces(res.data);
        setLoading(false);
    };

    useEffect(() => {
        fetchSpaces();
    }, []);

    const handleSubmit = async (data) => {
        let fileKey = null;
        const payload = {
            ...data,
        };

        if (data.document instanceof File) {
            const formData = new FormData();
            formData.append("file", data.document);

            const response = await uploadFile(formData);
            fileKey = response?.data.path;
            payload["photo_url"] = fileKey;
        }

        if (editingItem) {
            await updateSpace(editingItem.id, payload);
        } else {
            await createSpace(data);
        }
        fetchSpaces();
        setEditingItem(null);
    };

    const handleDelete = async (id) => {
        await deleteSpace(id);
        setShowDeleteModal(false);
        setShowSidebar(false);
        fetchSpaces();
    };

    return (
        <div className="p-6 mx-auto">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6 gap-4">
                <h1 className="text-2xl font-bold">Vos espaces</h1>
                <button
                    onClick={() => {
                        setShowSidebar(true);
                        setEditingItem(null);
                    }}
                    className="p-2 rounded-full hover:bg-green-100 transition"
                    title="Ajouter un espace"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-5 h-5 text-green-700"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 4v16m8-8H4"
                        />
                    </svg>
                </button>
            </div>
            {loading ? (
                <div className="text-center text-gray-400 p-10">
                    Chargement...
                </div>
            ) : spaces.length === 0 ? (
                <div className="text-center text-gray-500 p-10 border rounded-lg">
                    <p className="text-lg">Aucun espace créé pour le moment.</p>
                    <p>Ajoutez un nouvel espace pour commencer.</p>
                </div>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 p-6">
                    {spaces.map((item) => (
                        <div
                            key={item.id}
                            onClick={() => {
                                setEditingItem(item);
                                setShowSidebar(true);
                            }}
                            className="cursor-pointer bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow"
                        >
                            {item.photo_url ? (
                                <img
                                    src={item.photo_url}
                                    alt={item.name}
                                    className="h-48 w-full object-cover"
                                />
                            ) : (
                                <PlaceholderSVG />
                            )}

                            <div className="p-4">
                                <h2 className="text-xl font-semibold mb-2">
                                    {item.name}
                                </h2>
                                <p className="text-gray-600 mb-2">
                                    {item.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {showSidebar && (
                <SidebarForm
                    onClose={() => setShowSidebar(false)}
                    onSubmit={handleSubmit}
                    deleteSubmit={setDeleteNumber}
                    setShowDeleteModal={setShowDeleteModal}
                    initialData={editingItem}
                />
            )}

            {showDeleteModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center">
                    <div className="bg-white p-6 rounded-sm shadow-md text-center">
                        <p className="mb-4">
                            Voulez-vous vraiment supprimer cet espace ?
                        </p>
                        <div className="flex justify-center gap-4">
                            <button
                                onClick={() => setShowDeleteModal(false)}
                                className="px-4 py-2 bg-gray-300 rounded-sm hover:bg-gray-400"
                            >
                                Annuler
                            </button>
                            <button
                                onClick={() => handleDelete(deleteNumber)}
                                className="px-4 py-2 bg-red-600 text-white rounded-sm hover:bg-red-700"
                            >
                                Supprimer
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const SidebarForm = ({
    onClose,
    onSubmit,
    initialData,
    deleteSubmit,
    setShowDeleteModal,
}) => {
    const [form, setForm] = useState({
        name: "",
        type: "",
        address: "",
        quota: "",
        description: "",
        establishment_id: "",
        document: null,
    });
    const [establishments, setEstablishments] = useState([]);
    const [isZoomOpen, setIsZoomOpen] = useState(false);

    useEffect(() => {
        const fetchEstabs = async () => {
            const res = await getEstablishments();
            setEstablishments(res.data);
        };
        fetchEstabs();
    }, []);

    useEffect(() => {
        if (initialData) setForm(initialData);
    }, [initialData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setForm((prev) => ({ ...prev, document: e.target.files[0] }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(form);
        onClose();
    };

    return (
        <div className="fixed inset-0 z-40 flex justify-end">
            <div className="w-full max-w-md bg-white shadow-xl p-6 overflow-y-auto z-50 relative animate-slide-in-right">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                    aria-label="Fermer"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>
                <h2 className="text-xl font-bold mb-4">
                    {initialData ? "Modifier l'espace" : "Ajouter un espace"}
                </h2>
                <div>
                    {(form.photo_url ||
                        (typeof form.photo_url === "string" &&
                            form.photo_url)) && (
                        <div
                            className="mb-4 cursor-pointer"
                            onClick={() => setIsZoomOpen(true)}
                        >
                            <img
                                src={form.photo_url || form.photo_url}
                                alt="Aperçu"
                                className="w-full h-auto max-h-64 object-contain rounded-sm border hover:scale-105 transition-transform"
                            />
                        </div>
                    )}
                </div>
                <form className="space-y-4" onSubmit={handleSubmit}>
                    <input
                        name="name"
                        value={form.name}
                        onChange={handleChange}
                        placeholder="Nom"
                        className="w-full border p-2 rounded-sm"
                        required
                    />
                    <select
                        name="type"
                        value={form.type}
                        onChange={handleChange}
                        className="w-full border p-2 rounded-sm"
                        required
                    >
                        <option value="">-- Type d'espace --</option>
                        <option>Salle</option>
                        <option>Dépôt</option>
                        <option>Extérieur</option>
                        <option>Bureau</option>
                        <option>Autre</option>
                    </select>
                    <select
                        name="establishment_id"
                        value={form.establishment_id}
                        onChange={handleChange}
                        className="w-full border p-2 rounded-sm"
                        required
                    >
                        <option value="">-- Établissement --</option>
                        {establishments.map((e) => (
                            <option key={e.id} value={e.id}>
                                {e.name}
                            </option>
                        ))}
                    </select>
                    <input
                        name="address"
                        value={form.address}
                        onChange={handleChange}
                        placeholder="Adresse"
                        className="w-full border p-2 rounded-sm"
                    />
                    <input
                        name="quota"
                        value={form.quota}
                        onChange={handleChange}
                        placeholder="Capacité"
                        type="number"
                        className="w-full border p-2 rounded-sm"
                    />
                    <textarea
                        name="description"
                        value={form.description}
                        onChange={handleChange}
                        placeholder="Description"
                        className="w-full border p-2 rounded-sm"
                        rows={3}
                    />
                    <input
                        name="document"
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        className="w-full border p-2 rounded-sm"
                    />
                    <div className="text-right">
                        <button
                            type="button"
                            onClick={onClose}
                            className="m-1 border-2 border-gray-400 text-gray-400 hover:border-gray-600 hover:text-gray-600 max-h-12 rounded-sm font-bold py-2 px-4 focus:outline-hidden focus:shadow-outline"
                        >
                            Annuler
                        </button>
                        {initialData && (
                            <button
                                type="button"
                                onClick={() => {
                                    deleteSubmit(initialData.id);
                                    setShowDeleteModal(true);
                                    setForm({
                                        name: "",
                                        type: "",
                                        address: "",
                                        quota: "",
                                        description: "",
                                        establishment_id: "",
                                        photo_file: null,
                                    });
                                }}
                                className="m-1 border-2 border-red-500 text-red-500 hover:border-red-700 hover:text-red-700 max-h-12 rounded-sm font-bold py-2 px-4 focus:outline-hidden focus:shadow-outline"
                            >
                                Supprimer
                            </button>
                        )}

                        <button
                            type="submit"
                            className="m-1 border-2 border-app-primary text-app-primary hover:border-app-secondary hover:text-app-secondary max-h-12 rounded-sm font-bold py-2 px-4 focus:outline-hidden focus:shadow-outline"
                        >
                            {initialData ? "Mettre à jour" : "Ajouter"}
                        </button>
                    </div>
                </form>
            </div>
            {isZoomOpen && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center"
                    onClick={() => setIsZoomOpen(false)}
                >
                    <img
                        src={form.photo_url || form.photo_url}
                        alt="Zoom"
                        className="max-w-4xl max-h-[90vh] object-contain rounded-sm shadow-lg"
                    />
                </div>
            )}
        </div>
    );
};
